<template>
  <b-row style="position:relative">
    <b-col cols="4">
      <b-form @submit.prevent="onOperation(1)" autocomplete="off" ref="bsave">
        <div class="mb-2 position-relative">
          <div class="multiselect-lbl" v-if="shopObject && shopObject.eid">{{$t('Shop')}}</div>
          <multiselect
            v-model="shopObject"
            :options="shopList"
            placeholder="Select shop"
            track-by="eid"
            label="name"
            :multiple="false"
            :translate="false"
          ></multiselect>
        </div>
        <b-form-group class="mb-3">
          <date-range-picker
            :startDate="supplyDate"
            @update="updateSupplyDate"
            :locale-data="locale"
            opens="right"
            :timePicker="false"
            :ranges="false"
            :singleDatePicker="true"
            :label="$t('Supply Date')"
            style="width: 120px"
          />
        </b-form-group>
        <FloatingLabel
          v-model.number="supply.amount"
          label="Amount"
          size="sm"
          type="number"
          step="0.01"
        />
        <b-tabs content-class="mt-0" align="center" v-model="supply.optype">
          <b-tab :title="$t('Cash')" active>
            <div>
              <div class="mb-2 position-relative">
                <div class="multiselect-lbl" v-if="supply.operator">{{$t('Operator')}}</div>
                <multiselect
                  v-model="supply.cash_operator_id"
                  :options="operatorList"
                  placeholder="Select cash collector"
                  track-by="eid"
                  label="full_name"
                  :translate="false"
                ></multiselect>
              </div>
              <FloatingLabel
                v-model="supply.cash_order_number"
                label="Supply order number"
                size="sm"
              />
              <div class="mb-2 position-relative">
                <div class="multiselect-lbl" v-if="supply.subtype">{{$t('Subtype')}}</div>
                <multiselect
                  v-model="supply.subtype_id"
                  :options="subtypeList"
                  placeholder="Select subtype"
                  track-by="eid"
                  label="name"
                  :translate="false"
                  @select="(selected, id) => { selectedSubtype(selected, id, 1) }"
                ></multiselect>
              </div>
              <FloatingLabel
                v-model="supply.observations"
                label="Observation"
                autocomplete="false"
                type="textarea"
                size="sm"
              />
            </div>
          </b-tab>
          <b-tab :title="$t('Bank')">
            <div>
              <div class="mb-2 position-relative">
                <div class="multiselect-lbl" v-if="supply.operator">{{$t('Bank')}}</div>
                <multiselect
                  v-model="supply.bank_details_id"
                  :options="bankList"
                  placeholder="Select bank"
                  track-by="eid"
                  label="name"
                  :translate="false"
                ></multiselect>
              </div>
              <FloatingLabel
                v-model="supply.bank_order_number"
                label="Bank order number"
                size="sm"
              />
              <div class="mb-2 position-relative">
                <div class="multiselect-lbl" v-if="supply.subtype">{{$t('Subtype')}}</div>
                <multiselect
                  v-model="supply.subtype_id"
                  :options="subtypeList"
                  placeholder="Select subtype"
                  track-by="eid"
                  label="name"
                  :translate="false"
                  @select="(selected, id) => { selectedSubtype(selected, id, 1) }"
                ></multiselect>
              </div>
              <FloatingLabel
                v-model="supply.observations"
                label="Observation"
                autocomplete="false"
                type="textarea"
                size="sm"
              />
            </div>
          </b-tab>
        </b-tabs>
        <div style="text-align: right;">
          <b-button
            type="submit"
            variant="success"
            :disabled="!shopObject || !shopObject.eid"
          >{{$t('Save')}}</b-button>
        </div>
      </b-form>
    </b-col>
    <b-col cols="8" ref="b" style="border-left: 1px solid #dedede">
      <div class="filters-container d-flex flex-row justify-content-between">
        <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
        <DropdownColumns v-model="fields" class="customize" />
      </div>
      <div style="overflow-x:auto">
        <b-table
          id="balance-table-deposit"
          :busy.sync="isBusy"
          show-empty
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :hover="true"
          :striped="true"
          :items="provider"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          tbody-tr-class="tr-pointer"
          v-columns-resizable="{afterResize: columnsWidthChanged}"
        >
          <template v-slot:empty="scope">
            <div class="text-center">{{ $t(scope.emptyText) }}</div>
          </template>

          <template v-slot:head()="scope">{{ $t(scope.label) }}</template>

          <template v-slot:cell(type)="data">
            <span v-if="data.value == 1">{{ $t("Supply") }}</span>
            <span v-if="data.value == 2">{{ $t("Deposit") }}</span>
          </template>
          <template v-slot:cell(cash_operator_id)="data">
            <span v-if="data.value.to">
              <router-link :to="`/cash-collectors/${data.value.to}`">{{ data.value.name }}</router-link>
            </span>
            <span v-else>{{ data.value.name }}</span>
          </template>
          <template v-slot:cell(bank_details_id)="data">
            <span v-if="data.value.to">
              <router-link :to="`/banks/${data.value.to}`">{{ data.value.name }}</router-link>
            </span>
            <span v-else>{{ data.value.name }}</span>
          </template>
          <template v-slot:cell(subtype_id)="data">
            <span v-if="data.value.to">
              <router-link :to="`/subtypes/${data.value.to}`">{{ data.value.name }}</router-link>
            </span>
            <span v-else>{{ data.value.name }}</span>
          </template>
          <template v-slot:cell(amount)="data">
            <span>{{ roundThousands(data.value) }}</span>
          </template>
          <template v-slot:cell(timestamp)="data">
            <span>{{ mom_unix(data.value).format(tableDateShort) }}</span>
          </template>
          <template v-slot:cell(tx_timestamp)="data">
            <span>{{ mom_unix(data.value).format(tableDateMedium) }}</span>
          </template>
        </b-table>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div style="white-space:nowrap;" class="my-2">
            <PaginationSelect
              v-model="perPage"
              :options="paginationOpts"
              variant="brand"
              size="sm"
            />
            <span>
              &nbsp;
              <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                <span slot="end">{{currentPage * perPage}}</span>
                <span slot="total">{{totalRows}}</span>
              </i18n>
            </span>
            <b-button
              size="sm"
              @click.stop="$root.$emit('bv::refresh::table', 'balance-table-deposit')"
              class="ml-2 refresh"
              variant="light"
              :title="$t('Refresh')"
            >
              <i class="icon-refresh"></i>
            </b-button>
          </div>
          <nav class="ml-auto mt-2">
            <b-pagination
              size="md"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </nav>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf, successConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import tableMixin from "@/shared/mixins/table.mixin";
import DropdownColumns from "@/components/DropdownColumns";
import FloatingLabel from "@/components/FloatingLabel";
import Multiselect from "@/components/multiselect-filters";
import TableFilters from "@/components/TableFilters";
import DateRangePicker from "@/components/calendar-range/DateRangePicker";
import timeFormat from "@/shared/timeFormat";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    FloatingLabel,
    Multiselect,
    DateRangePicker,
    TableFilters
  },
  name: "CashTransactionDeposit",
  props: ["eshop_id", "shop_name"],
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "balanceDeposit",
      isBusy: false,

      filterOptions: [
        {
          field: "timestamp",
          type: "date",
          opens: "right",
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documenations for details
            showWeekNumbers: true //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month")
          },
          default: {
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month")
          },
          ranges: false
        }
      ],

      sortBy: "timestamp",
      sortDesc: true,
      fields: [
        {
          key: "timestamp",
          label: "Date",
          sortable: true,
          ignore: true
        },
        {
          key: "tx_timestamp",
          label: "Transaction Date",
          sortable: true,
          ignore: true
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
          ignore: true
        },
        {
          key: "amount",
          label: "Amount",
          sortable: false,
          ignore: true
        },
        {
          key: "cash_operator_id",
          label: "Cash Collector",
          sortable: false,
          ignore: true
        },
        {
          key: "cash_order_number",
          label: "Supply/Deposit order number",
          sortable: false,
          ignore: true
        },
        {
          key: "bank_details_id",
          label: "Bank",
          sortable: false,
          ignore: true
        },
        {
          key: "bank_order_number",
          label: "Bank order number",
          sortable: false,
          ignore: true
        },
        {
          key: "subtype_id",
          label: "Subtype",
          sortable: false,
          ignore: true
        },
        {
          key: "observations",
          label: "Observations",
          sortable: false,
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null,

      locale: {
        format: timeFormat.datePickerShort, //format of the dates displayed
        firstDay: 1, //ISO first day of week - see moment documenations for details
        showWeekNumbers: true //show week numbers on each row of the calendar
      },

      supplyDate: moment(),
      shopObject: null,
      supply: {
        eid: null,
        eshop_id: null,
        timestamp: null,
        optype: 0,
        amount: "",
        cash_operator_id: null,
        cash_order_number: "",
        bank_details_id: null,
        bank_order_number: "",
        subtype_id: null,
        observations: ""
      }
    };
  },
  computed: {
    operatorList() {
      return this.$store.getters["cache/operators"];
    },
    bankList() {
      return this.$store.getters["cache/banks"];
    },
    subtypeList() {
      return this.$store.getters["cache/subtypes"];
    },
    shopList() {
      return this.$store.getters["cache/shops"];
    }
  },
  mounted() {
    const _this = this;
    Promise.all([
      this.$store.dispatch("cache/fetch", "banks").catch(e => e),
      this.$store.dispatch("cache/fetch", "operators").catch(e => e),
      this.$store.dispatch("cache/fetch", "subtypes").catch(e => e),
      this.$store.dispatch("cache/fetch", "shops").catch(e => e)
    ])
      .catch(err => {})
      .finally(() => {
        if (_this.eshop_id != "0" && _this.eshop_id != "") {
          _this.shopObject = {
            eid: this.eshop_id,
            name: this.shop_name
          };
          _this.$root.$emit("bv::refresh::table", "balance-table-deposit");
        }
        _this.clear();
      });
  },
  watch: {
    shopObject: {
      handler: function(newShop) {
        this.$root.$emit("bv::refresh::table", "balance-table-deposit");
        this.updateCashOrderNumber();
      },
      deep: true
    }
  },
  methods: {
    updateCashOrderNumber() {
      if (this.shopObject && this.shopObject.eid) {
        this.$store
          .dispatch("shopCashTX/count", {
            exactFields: ["shop_id", "type", "ISNULL bank_details_id"],
            exactValues: [[this.shopObject.eid], [1, 2], [""]]
          })
          .then(r => {
            console.log("response", r);
            let countOrderNumber = 0;
            r.data.rows.forEach(e => {
              if (typeof e["ebank_details_id"] === "undefined") {
                countOrderNumber += 1;
              }
            });
            this.supply.cash_order_number = `${countOrderNumber + 1}`;
          });
      }
    },
    clear() {
      this.supply = {
        eid: null,
        eshop_id: null,
        timestamp: null,
        optype: 0,
        amount: "",
        cash_operator_id: null,
        cash_order_number: "",
        bank_details_id: null,
        bank_order_number: "",
        subtype_id: null,
        observations: ""
      };
      this.supply.eshop_id =
        this.shopObject && this.shopObject.eid ? this.shopObject.eid : null;
      this.supply.timestamp = new Date().getTime() * 1e6;
      this.supply.bank_order_number = moment().format("DD.MM.YYYY");
      this.supplyDate = moment();
    },
    selectedSubtype(selected, id, type) {
      this[type == 1 ? "supply" : "withdrawal"].observations =
        selected.observation;
    },
    updateSupplyDate(value) {
      this.supply.timestamp = new Date(value.startDate).getTime() * 1e6;
    },
    redirect() {},
    refresh() {
      this.$root.$emit("bv::refresh::table", "balance-table-deposit");
    },
    onOperation(type) {
      // 1 - supply; 2 - withdrawal
      const loader = this.$loading.open({
        container: this.$refs.bsave
      });

      const apiAction = "shopCashTX/create";

      const postData = {};
      postData.eshop_id =
        this.shopObject && this.shopObject.eid ? this.shopObject.eid : null;
      postData.type = type == 1 ? 1 : 2; // 1 - supply; 2 - withdrawal
      postData.timestamp = this[type == 1 ? "supply" : "withdrawal"].timestamp;
      postData.amount = parseInt(
        this[type == 1 ? "supply" : "withdrawal"].amount * 10000
      );

      if (this[type == 1 ? "supply" : "withdrawal"].optype == 0) {
        //cash
        if (this[type == 1 ? "supply" : "withdrawal"].cash_operator_id) {
          postData.ecash_operator_id = this[
            type == 1 ? "supply" : "withdrawal"
          ].cash_operator_id.eid;
        }
        postData.cash_order_number = this[
          type == 1 ? "supply" : "withdrawal"
        ].cash_order_number;
      } else {
        if (this[type == 1 ? "supply" : "withdrawal"].bank_details_id) {
          postData.ebank_details_id = this[
            type == 1 ? "supply" : "withdrawal"
          ].bank_details_id.eid;
        }
        postData.bank_order_number = this[
          type == 1 ? "supply" : "withdrawal"
        ].bank_order_number;
      }

      if (this[type == 1 ? "supply" : "withdrawal"].subtype_id) {
        postData.esubtype_id = this[
          type == 1 ? "supply" : "withdrawal"
        ].subtype_id.eid;
      }
      postData.observations = this[
        type == 1 ? "supply" : "withdrawal"
      ].observations;

      postData.tx_timestamp = new Date().getTime() * 1e6;

      this.$store
        .dispatch(apiAction, postData)
        .then(resp => {
          const msg = (type == 1 ? "Supply" : "Deposit") + " created";
          this.showSuccessNotification(msg);
          this.$root.$emit("bv::refresh::table", "balance-table-deposit");
          this.clear();
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    provider(ctx, callback) {
      if (!(this.shopObject && this.shopObject.eid)) {
        callback([]);
        return;
      }

      const loading = this.$loading.open({
        container: this.$refs.b
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
        exactFields: ["shop_id"],
        exactValues: [[this.shopObject.eid]]
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          exactValues.push(item.selected);
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("month");
            paginationData.dateEnd = moment().endOf("month");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const bankByID = this.$store.getters["cache/bankByID"];
      const operatorByID = this.$store.getters["cache/operatorByID"];
      const subtypeByID = this.$store.getters["cache/subtypeByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "banks").catch(e => e),
        this.$store.dispatch("cache/fetch", "operators").catch(e => e),
        this.$store.dispatch("cache/fetch", "subtypes").catch(e => e)
      ])
        .catch(err => {})
        .finally(() => {
          this.$store
            .dispatch("shopCashTX/fetch", paginationData)
            .then(resp => {
              this.totalRows = resp.data.total;
              resp.data.rows.forEach((item, index) => {
                if (item.ecash_operator_id) {
                  const data = operatorByID(item.ecash_operator_id);
                  if (data) {
                    item.cash_operator_id = {
                      to: item.ecash_operator_id,
                      name: data.full_name
                    };
                  } else {
                    item.cash_operator_id = {
                      to: null,
                      name: item.ecash_operator_id
                    };
                  }
                }
                if (item.ebank_details_id) {
                  const data = bankByID(item.ebank_details_id);
                  if (data) {
                    item.bank_details_id = {
                      to: item.ebank_details_id,
                      name: data.name
                    };
                  } else {
                    item.bank_details_id = {
                      to: null,
                      name: item.ebank_details_id
                    };
                  }
                }
                if (item.esubtype_id) {
                  const data = subtypeByID(item.esubtype_id);
                  if (data) {
                    item.subtype_id = {
                      to: item.esubtype_id,
                      name: data.name
                    };
                  } else {
                    item.subtype_id = {
                      to: null,
                      name: item.esubtype_id
                    };
                  }
                }
              });
              callback(resp.data.rows);
            })
            .catch(err => {
              this.$bvToast.toast(
                this.$t(err.message),
                errorConf(this.$t("Error"))
              );
              this.totalRows = 0;
              callback([]);
            })
            .finally(() => {
              loading.close();
            });
        });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep #balance-table-deposit th {
  text-transform: capitalize;
}
</style>




